import {
  APPOINTMENTS_FAIL,
  GET_PAST_APPOINTMENTS,
  GET_UPCOMMING_APPOINTMENTS,
} from './types';

const initialState = {
  upcommingAppointments: [],
  pastAppointments: [],
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_UPCOMMING_APPOINTMENTS:
      console.log('getupcomingappt payload', payload);
      return {
        ...state,
        upcommingAppointments: payload,
        loading: false,
      };
    case GET_PAST_APPOINTMENTS:
      return {
        ...state,
        pastAppointments: payload,
        loading: false,
      };
    case APPOINTMENTS_FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
